import React from 'react';
import { SectionCta } from './SectionCta';
const steps = ['You open the Desk.', 'You identify the scenario.', 'You follow the relevant decision path.', 'You review the supporting information.', 'And you continue your clinical reasoning from there.'];
export function ImagineSection() {
  return <section className="w-full bg-navy px-5 py-14 sm:px-6 sm:py-20" data-id="element-169" data-mp="11qlfr72050ir">
      <div className="mx-auto max-w-3xl" data-id="element-170" data-mp="ns59tibyre1o">
        <h2 className="font-serif text-[28px] font-bold leading-[1.12] text-cream sm:text-4xl" data-id="element-171" data-mp="nr2lni60zppg">
          Imagine your next consultation
        </h2>

        <p className="mt-5 text-[16px] leading-relaxed text-cream/70 sm:text-[17px]" data-id="element-172" data-mp="dtpknkwhyeut">
          A patient presents with menopausal symptoms. You have questions to answer.
        </p>

        <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-173" data-mp="iulwckn3b5as">
          <div className="rounded-xl border border-white/12 p-4" data-id="element-174" data-mp="2890h6tuzm810">
            <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-cream/45" data-id="element-175" data-mp="2d6jy61j2kywn">Instead of thinking</p>
            <p className="mt-2 font-serif text-[17px] font-semibold italic leading-snug text-cream/70" data-id="element-176" data-mp="hva5k88l0e34">
              “Which guideline should I open?”
            </p>
          </div>
          <div className="rounded-xl border-2 border-gold bg-white/[0.06] p-4" data-id="element-177" data-mp="rlln4xl6ulsh">
            <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-gold-light" data-id="element-178" data-mp="rnoepm1zomzb">You think</p>
            <p className="mt-2 font-serif text-[17px] font-semibold italic leading-snug text-cream" data-id="element-179" data-mp="3v2kdtqj4x8fx">
              “Which pathway am I in?”
            </p>
          </div>
        </div>

        <ol className="mt-7 space-y-2.5" data-id="element-180" data-mp="3q5tvsxnrs2rv">
          {steps.map((step, i) => <li key={step} className="flex items-start gap-3" data-id="element-181" data-mp="7z783food3mi" data-mpi={i}>
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-light font-serif text-[12px] font-bold text-ink" data-id="element-182" data-mp="3w0zw2i052de">
                {i + 1}
              </span>
              <span className="pt-0.5 text-[15px] leading-snug text-cream/85" data-id="element-183" data-mp="1fc7iboa3gbl2">{step}</span>
            </li>)}
        </ol>

        <p className="mt-8 border-l-2 border-gold pl-4 text-[15.5px] leading-relaxed text-cream/75" data-id="element-184" data-mp="c0a93gc6sp23">
          Information gives you possibilities.{' '}
          <strong className="font-bold text-cream" data-id="element-185" data-mp="ly6k8854jk07">A decision system gives you a path to navigate them.</strong>
        </p>

        <SectionCta headline="Walk into your next consultation with a pathway, not a search." label="Yes, I want that structure" variant="gold" data-id="element-186" data-mp="pz066vz0aoqg" />
      </div>
    </section>;
}